import styled from "styled-components";

export const CrmChartStyle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
